import {Customer_CustomerGender} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/customer.types';
import {AuthMedium, UserGenders} from '../userStore/types';

export const mapCustomerGenderToUserGender = (
  gender: Customer_CustomerGender,
): Exclude<UserGenders, UserGenders.Kids> =>
  gender === Customer_CustomerGender.MALE
    ? UserGenders.Male
    : UserGenders.Female;

export const mapAuthenticationMethodToAuthMedium = (
  authenticationMethodType: string,
): AuthMedium =>
  authenticationMethodType === 'password' ? 'email' : authenticationMethodType;
